import { Box } from "@chakra-ui/react";
import { BellIcon as BellIconPhosphor } from "@phosphor-icons/react";

export function BellIcon() {
  return (
    <Box
      as="span"
      color="black"
      transition="color 0.2s"
      _hover={{
        color: "red",
      }}
    >
      <BellIconPhosphor size={20} weight="regular" />
    </Box>
  );
}